import React from 'react';

/**
 * Logo component for Plus branding
 * @param {Object} props
 * @param {string} props.variant - 'full' for full logo, 'compact' for P. icon only
 * @param {string} props.size - 'sm', 'md', 'lg', 'xl' or custom className
 * @param {string} props.className - Additional CSS classes
 */
const Logo = ({ variant = 'full', size = 'md', className = '' }) => {
  const sizeClasses = {
    sm: variant === 'full' ? 'h-8' : 'h-8 w-8',
    md: variant === 'full' ? 'h-10' : 'h-10 w-10',
    lg: variant === 'full' ? 'h-12' : 'h-12 w-12',
    xl: variant === 'full' ? 'h-14' : 'h-14 w-14',
  };

  const sizeClass = sizeClasses[size] || size;

  if (variant === 'compact') {
    return (
      <img
        src="/logo-plus-compact.png"
        alt="Plus"
        className={`${sizeClass} object-contain ${className}`}
        data-testid="logo-compact"
      />
    );
  }

  return (
    <img
      src="/logo-plus.png"
      alt="Plus"
      className={`${sizeClass} object-contain ${className}`}
      data-testid="logo-full"
    />
  );
};

export default Logo;
